import type { AutoDispatchOverviewResponse } from '@api/useAutoDispatch/response'

export type SelectedRun = {
  id: string
  created_by: string
  created_on: string
  canceled_by: string
  canceled_on: string
}

export type CreateNewRunProps = {
  startOptimizerRun: () => void
  depots: string[]
  handleOrderSelectionChanged: (selectedOrders: AutoDispatchOverviewResponse[]) => void
  loading: string | boolean
  orderData: AutoDispatchOverviewResponse[]
  scheduleData: ScheduleData[]
  selectedRun: SelectedRun
  resetOptimizer: () => void
}

export type ScheduleData = {
  shift: string
  rows: Gravitate.Schedule[]
}

export type NewRunHeaderProps = {
  startOptimizerRun: () => void
  loading?: string | boolean
  selectedRun: SelectedRun
  resetOptimizer: () => void
}

export type ScheduleGridProps = {
  scheduleData: ScheduleData[]
  depots: string[]
  selectedRun: SelectedRun
  loading?: boolean
}

export type OrderGridProps = {
  orderData: AutoDispatchOverviewResponse[]
  handleOrderSelectionChanged: (selectedOrders: AutoDispatchOverviewResponse[]) => void
  loading: boolean
  selectedRun: SelectedRun
}

export type CancelRunButtonProps = {
  selectedRunId: string
  createdBy: string
  width?: string
  resetOptimizer: () => void
}

export type OptimizerWizardProps = {
  mode: string | null
  setMode: (mode: string | null) => void
  depots: any[]
  visible: boolean
  setVisible: (visible: boolean) => void
  schedulePayload: {
    viewDate: string
    shift: string
  }
  refetchOrders: () => void
  refetchDriverSchedule: () => void
  ordersFromDispatch?: Gravitate.Order[]
}

export type ReviewResultsProps = {
  closeWizard: (refresh?: boolean) => void
  selectedRun: SelectedRun
  resetOptimizer: () => void
}

export type ReviewHeaderProps = {
  data?: AutoDispatchOverviewResponse
  closeWizard: (refresh?: boolean) => void
  resetOptimizer: (refresh?: boolean) => void
  selectedId?: string
  createdBy?: string
}

export const ROUTE_OPTIMIZER_MODE = {
  CREATE: 'CREATE',
  DEFAULT: 'DEFAULT',
  EDIT: 'EDIT',
  REVIEW: 'REVIEW',
  USER_REVIEW: 'USER_REVIEW',
} as const

export type RouteOptimizerMode = (typeof ROUTE_OPTIMIZER_MODE)[keyof typeof ROUTE_OPTIMIZER_MODE]
